/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { EmergencyPlanViewModel } from './EmergencyPlanViewModel'; 

export function getEmergencyPlanBySignatureOptions(signatureId: string, onSuccess?: (result?: EmergencyPlanViewModel) => void) {
	return queryOptions({
		queryKey: ['emergency-plan-by-signature', signatureId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/incidents/emergencyplanning/queries/getemergencyplanbysignature/' + signatureId;
			const resp = await axios.get<EmergencyPlanViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(signatureId)
	});
}